import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class SellerListItem extends React.Component {
    render = () => {
        const {
            id,
            cuit,
            estado,
            telefono,
            direccion,
            localidad,
            provincia,
            razonSocial,
            codigoPostal,
            emailContacto,
            numeroDomicilio,
            contactoComercial,
            onToggleStatus,
        } = this.props;


        const estados = {
            activo: { label: "ACTIVO", className: "admin-status-pill admin-status-pill--activo admin-status-pill--interactive" },
            inactivo: { label: "INACTIVO", className: "admin-status-pill admin-status-pill--inactivo admin-status-pill--interactive" }
        }


        const renderStatusLabel = () => { 
            const { label, className } = estados[estado] || { label: "", className: "label" }
            return (
                <button
                    style={{ textAlign: "center", display: "inline-flex", userSelect: "none" }}
                    className={className}
                    onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggleStatus();
                }}
                >
                    {label}
                </button>
            )
        };

        const estadoCardClass = estado === "activo"
            ? "admin-list-card--vigente"
            : "admin-list-card--inactivo";

        return (
            <Link
                className={`list-group-item hover-background-color admin-list-card seller-list-card p-3 ${estadoCardClass}`}
                style={{ cursor: "pointer" }}
                to={`/Sellers/Editar/${id}`}
            >
            <div className="col-md-12 col-lg-12 col-12 col-sm-12 d-none d-sm-none d-md-block">

                <div className="row">

                    <div className="col-md-3 col-lg-3">
                        <h6 className="box-title m-b-5 font-weight-bold admin-list-card__title">{razonSocial}</h6>
                        <small className="font-14">{cuit}</small>
                        <br />
                    </div>

                    <div className="col-md-4 col-lg-4">
                        <small className="font-14">
                            <i className="fas fa-envelope" /> {emailContacto}
                        </small>
                        <br />
                        <small className="font-14">
                            <i className="fas fa-phone" /> {telefono}
                        </small>
                    </div>

                    <div className="col-md-3 col-lg-3">
                        <small className="font-14">
                            <i className="fas fa-map-marker-alt" /> {direccion} {numeroDomicilio}
                        </small>
                        <br />
                        <small className="font-14">{codigoPostal} - {localidad}</small>
                        <br />
                        <small className="font-14">{provincia}</small>
                    </div>

                    <div className="col-md-2 col-lg-2 col-4 align-self-center">
                        {renderStatusLabel()}
                    </div>
                </div>
            </div>

            {/* Vista Mobile */}
            <div className="col-md-8 col-lg-11 col-10 col-sm-10 d-block d-sm-block d-md-none">

                <div className="row">

                    <div className="col-md-12 col-lg-12 col-12">
                        <h6 className="box-title m-b-0 admin-list-card__title">{razonSocial}</h6>
                    </div>

                    <div className="col-md-12 col-lg-12 col-12">
                        <small>{contactoComercial}</small><br />
                        <small >{emailContacto} | {telefono}</small>
                    </div>

                    <div className="col-md-10 col-lg-10 col-10 p-r-0">
                        <small>{cuit}</small>
                        <br />
                        <small>{direccion} - {codigoPostal} - {localidad} - {provincia}</small>
                    </div>

                    <div className="col-md-2 col-lg-2 col-2 align-self-center">
                        {renderStatusLabel()}
                    </div>
                </div>
            </div>
            </Link>
        );
    }
}
SellerListItem.propTypes = {
    id: PropTypes.number,
    cuit: PropTypes.string,
    estado: PropTypes.string,
    telefono: PropTypes.string,
    direccion: PropTypes.string,
    localidad: PropTypes.string,
    provincia: PropTypes.string,
    razonSocial: PropTypes.string,
    codigoPostal: PropTypes.number,
    emailContacto: PropTypes.string,
    numeroDomicilio: PropTypes.number,
    contactoComercial: PropTypes.string,
    onToggleStatus: PropTypes.func,
}